import { signal } from "@preact/signals-react";
import { Song } from "stuen-common";

export const songs = signal<Song[]>([]);
export const isSearcingSongs = signal<boolean>(false);
